import React, { useEffect } from 'react';
import { useStyles } from './style';
import { Box } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useStores } from '../../hooks/use-stores';
import CurrentDiscount from './DiscountCard/CurrentDiscount';
import FutureDiscount from './DiscountCard/FutureDiscount';
import TotalRentDays from './DiscountCard/TotalRentDays';

const DiscountCard = observer(({ title, type, withRequest, withBottomPadding }) => {
    const { DiscountStore: store } = useStores();
    const classes = useStyles();

    // Effects
    useEffect(() => {
        if (withRequest) {
            store.getDiscounts();
        }
    }, [store, withRequest]);

    // Renders
    const renderCard = () => {
        switch (type) {
            case 'current':
                return (
                    <CurrentDiscount
                        title={title}
                        loading={store.loading}
                        discount={store.discount?.current_discount?.value}
                        withBottomPadding={withBottomPadding}
                    />
                );
            case 'future':
                return (
                    <FutureDiscount
                        loading={store.loading}
                        discount={store.discount && store.discount?.future_discount?.value}
                        rentDays={store.discount?.days_left_accumulate?.value}
                        withBottomPadding={withBottomPadding}
                    />
                );
            case 'rentDays':
                return <TotalRentDays loading={store.loading} rentDays={store.discount?.accumulated_rental_days?.value} />;

            default:
                break;
        }
    };

    return <Box className={classes.card}>{renderCard()}</Box>;
});

export default DiscountCard;
